// extracted by mini-css-extract-plugin
export default {"button":"navigator_button__NGIOG","button--next":"navigator_button--next__B2Thx","button__icon":"navigator_button__icon__VRDpB"};